var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcExport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "export") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-story",
    transform: "translate(-22.000000, -640.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(9.000000, 625.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "export",
    transform: "translate(13.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.34107143,23 L19.0160714,23 C20.3071383,22.9954936 21.3526365,21.9499954 21.3571429,20.6589286 L21.3571429,9.85714286 C21.3571429,9.40348038 20.9893768,9.03571429 20.5357143,9.03571429 C20.0820518,9.03571429 19.7142857,9.40348038 19.7142857,9.85714286 L19.7142857,20.6589286 C19.7142857,20.8441065 19.6407241,21.0217 19.5097835,21.1526406 C19.3788429,21.2835812 19.2012494,21.3571429 19.0160714,21.3571429 L2.34107143,21.3571429 C1.95545833,21.3571429 1.64285714,21.0445417 1.64285714,20.6589286 L1.64285714,3.98392857 C1.64285714,3.59831547 1.95545833,3.28571429 2.34107143,3.28571429 L13.1428571,3.28571429 C13.5965196,3.28571429 13.9642857,2.91794819 13.9642857,2.46428571 C13.9642857,2.01062324 13.5965196,1.64285714 13.1428571,1.64285714 L2.34107143,1.64285714 C1.05000459,1.64736353 0.00450638262,2.69286173 0,3.98392857 L0,20.6589286 C0.00450638262,21.9499954 1.05000459,22.9954936 2.34107143,23 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1785714,7.39285714 C22.6322339,7.39285714 23,7.02509104 23,6.57142857 L23,0.821428571 C23,0.367766098 22.6322339,0 22.1785714,0 L16.4285714,0 C15.974909,0 15.6071429,0.367766098 15.6071429,0.821428571 C15.6071429,1.27509104 15.974909,1.64285714 16.4285714,1.64285714 L20.1989286,1.64285714 L8.4525,13.3810714 C8.29699318,13.5353083 8.20952281,13.745262 8.20952281,13.9642857 C8.20952281,14.1833094 8.29699318,14.3932632 8.4525,14.5475 C8.60673685,14.7030068 8.8166906,14.7904772 9.03571429,14.7904772 C9.25473798,14.7904772 9.46469172,14.7030068 9.61892857,14.5475 L21.3571429,2.80107143 L21.3571429,6.57142857 C21.3571429,7.02509104 21.724909,7.39285714 22.1785714,7.39285714 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExport);
export default __webpack_public_path__ + "static/media/icExport.cf5c6dcc56dff82e36a75fe617ed4db7.svg";
export { ForwardRef as ReactComponent };